import gql from 'graphql-tag'

export default gql`query organizers($filter:FilterFindManyOrganizerInput){
    organizerUsers(filter:$filter){
      _id
      name
      username
    }
  }`
